import React from 'react'

const DeliveryListing = ({ pickupList, handleUpdateModal, fetchOrderDetails, setDeliveryId, orderList }) => {
    return (
        <div className='mx-auto w-full max-w-5xl px-3 py-4 sm:px-5' >
            <h3 className='text-left text-xl font-[GilroyBold] text-slate-900' >Assigned deliveries</h3>
            <p className='mt-1 text-sm text-slate-500'>Upload POD and update the status for every assigned order.</p>
            <div className='mt-5 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm' >
                <div className='hidden bg-slate-100 py-4 px-4 sm:grid sm:grid-cols-[1fr_2fr_120px] sm:gap-3'>
                    <p className='col-span-1 text-center font-[GilroyMedium]' >Lr No</p>
                    <p className='col-span-2 text-center font-[GilroyMedium]' >Address</p>
                    <p className='col-span-1 text-center font-[GilroyMedium]' >Status</p>

                </div>

                {
                    orderList.map((item) => {
                        let addr = item?.dropoff_location
                        if (!addr && item?.delivery_address) {
                            try { addr = typeof item.delivery_address === 'object' ? item.delivery_address : JSON.parse(item.delivery_address) } catch (_) { addr = {} }
                        }
                        return (
                    <div key={item.id} className='grid gap-3 border-t border-slate-200 px-4 py-4 sm:grid-cols-[1fr_2fr_120px] sm:items-center'>

                                <div className='text-sm font-[GilroyMedium] text-slate-800'>
                                    <span>{String((item?.order_number ?? item?.tracking_number) ?? '-')}</span>
                                </div>
                                <div className='text-sm font-[GilroyMedium] text-slate-500'>
                                    <span>{addr?.address}{addr?.address ? ', ' : ''}{addr?.city}{addr?.city ? ', ' : ''}{addr?.region}{addr?.region ? ', ' : ''}{addr?.zip}</span>
                                    {addr?.phone && <div>{addr?.phone}</div>}
                                </div>
                                <div className='flex items-center justify-start sm:justify-end'>
                                    <button type='button' onClick={() => {
                                        fetchOrderDetails(item?.id)
                                        handleUpdateModal()
                                        setDeliveryId(item?.id)
                                    }} className='rounded-xl bg-slate-950 px-4 py-2 text-xs font-[GilroyMedium] text-white' >Upload POD / Update</button>
                                </div>

                            </div>
                        )
                    })
                }
                {!orderList.length && <div className='px-4 py-10 text-center text-sm text-slate-500'>No assigned deliveries found.</div>}

            </div>

        </div>
    )
}

export default DeliveryListing
